import { render, staticRenderFns } from "./CompanyProfiles.vue?vue&type=template&id=a5ebaac4&scoped=true&lang=pug"
import script from "./CompanyProfiles.vue?vue&type=script&lang=ts"
export * from "./CompanyProfiles.vue?vue&type=script&lang=ts"
import style0 from "./CompanyProfiles.vue?vue&type=style&index=0&id=a5ebaac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ebaac4",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.shared.global.company_profiles.types?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2FCompanyProfiles.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.shared.global.company_profiles.types?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2FCompanyProfiles.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)
import block2 from "@locales/de/de.yml?namespace=ui.views.company_profiles.index?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2FCompanyProfiles.vue&locale=de&lang=yaml&external"
if (typeof block2 === 'function') block2(component)
import block3 from "@locales/en/en.yml?namespace=ui.views.company_profiles.index?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2FCompanyProfiles.vue&locale=en&lang=yaml&external"
if (typeof block3 === 'function') block3(component)

export default component.exports